/*
 * File: utills.js
 * Project: digital-catalogue
 * File Created: Wednesday, 20th December 2023 1:29:18 pm
 * Author: Gurruprasad BR (you@you.you)
 * -----
 * Last Modified: Friday, 15th March 2024 6:55:57 pm
 * Modified By: Gurruprasad BR (you@you.you>)
 */

import { matchRoutes } from 'react-router-config';
import axios from 'axios';
import Routes from './Routes';
import { getStore, getSessionStore, getProductsStore } from '../store/createStore';
import config from '../config/config';
import queryString from "query-string";
import { AddPriceCardDataonClick } from './pages/listing/addpricecard.utils';
import { getOutDatedPriceCardData } from './common/Feature/OutDatedPriceCard/utils';
import { getCategoryMissingCardData } from './common/Feature/CategoryMissing/utils';
import CryptoJS from "crypto-js";
const staticImageDomains = config.staticImageDomains[0];
const excapeRegex = /[-\/\\^$*+?.()|[\]{}]/g;

export const getMatchedRoutes = (path, options = {}) => {
	const routes = matchRoutes(Routes, path);
	return routes;
}

export const changeMobileNo = (str) => {
	let result;
	if (str.length == 10) {
		result = str.substr(0, 2) + 'xxxx' + str.substr(str.length - 4, 4);
	}
	return result;
};

export const changeEmailIds = (str) => {
	let result;
	if (str) {
		let lastPart = str.split("@");
		let firstPart = lastPart[0];
		lastPart = '@' + lastPart[1];
		let fPart, lPart, mask;
		if (firstPart.length > 6) {
			fPart = firstPart.substr(0, 2);
			lPart = firstPart.substr(firstPart.length - 4);
			mask = firstPart.substring(2, firstPart.length - 4).replace(/\d/g, "*").replace(/\D/g, '*');
			result = fPart + mask + lPart + lastPart;
		} else if (firstPart.length > 3) {
			fPart = firstPart.substr(0, 1);
			lPart = firstPart.substr(firstPart.length - 2);
			mask = firstPart.substring(1, firstPart.length - 2).replace(/\d/g, "*").replace(/\D/g, '*');
			result = fPart + mask + lPart + lastPart;
		} else {
			result = firstPart + lastPart;
		}
	}
	return result;
};

export const formatLoginData = (loginData = {}) => {
	let result = JSON.parse(JSON.stringify(loginData));
	if (Object.keys(result).length == 0) {
		return result;
	}
	if (result.ownerMobileList?.length) {
		result.ownerMobileList = result.ownerMobileList.map((item) => {
			return changeMobileNo(item);
		});
	}
	// if(result.employeeMobileList.length){
	// 	result.employeeMobileList = result.employeeMobileList.map((item) => {
	// 		return changeMobileNo(item);
	// 	});
	// }
	if (result.ownerEmailList?.length) {
		result.ownerEmailList = result.ownerEmailList.map((item) => {
			return changeEmailIds(item);
		});
	}
	// if(result.employeeEmailList.length){
	// 	result.employeeEmailList = result.employeeEmailList.map((item) => {
	// 		return changeEmailIds(item);
	// 	});
	// }
	return result;
};

export const checkLoggedIn = (options = {}) => {
	let { cb, history, discount, inventory, orderListing, isJdMartToken } = options;
	let session = getSessionStore();
	let products = getProductsStore();
	let userData = session.user;
	let loginUrl = discount ? '/products/login?fromDiscount=true' : inventory ? '/products/login?fromInventory=true' : orderListing ? '/products/login?fromOrderListing=true' : '/products/login';
	let authUrl = discount ? '/products/auth?fromDiscount=true' : inventory ? '/products/auth?fromInventory=true' : orderListing ? '/products/auth?fromOrderListing=true' : '/products/auth';
	if (history && session.showCompanyDetails && !userData.loggedUser) {
		if (products?.isEnrich) {
			history.push('/contractor-login/v4');
		} else {
			if (userData.noUserCheck) {
				history.push(loginUrl);
			} else {
				history.push(authUrl);
			}
		}
	} else {
		cb && cb();
	}
};

export const loadRouteData = (location, options = {}) => {
	const path = location.pathname;
	const store = getStore();
	const routes = getMatchedRoutes(path);
	if (!routes.length) {
		if (__isBrowser__) {
			return window.location.reload();
		} else {
			return Promise.resolve({
				notFoundPage: true
			});
		}
	}
	const matchedRoute = routes[0].route;
	const promises = routes
		.map(({ route, match }) => {
			let promiseArr = [];
			if (!options.loadType || options.loadType == 'clientData') {
				promiseArr.push(route.clientData ? route.clientData(store, match, location, matchedRoute) : null);
			}
			if (!options.loadType || options.loadType == 'loadData') {
				promiseArr.push(route.loadData ? route.loadData(store, match, location, matchedRoute) : null);
			}
			if (route.component.load) {
				promiseArr.push(route.component.load());
			}
			return Promise.all(promiseArr);
		})
		.map(promise => {
			if (!promise) {
				return null;
			}
			return new Promise(resolve => {
				const resolveCb = (data) => {
					resolve({
						...data,
						routeData: matchedRoute
					})
				}
				promise.then(resolveCb).catch(resolveCb);
			});
		});
	return Promise.all(promises);
};

export const setCookie = (cname, cvalue, exdays) => {
	let d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
};

export const removeDoubleBackSlash = obj => {
	if (typeof obj == 'string') {
		obj = obj.replace('//', '/');
		return obj;
	}
	return null;
};

export const getParameterByName = name => {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
		results = regex.exec(location.search);
	return results === null
		? ''
		: decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const getApplicableTax = (option) => {
	var UTList = ["Andaman and Nicobar", "Chandigarh", "Dadra and Nagar Haveli", "Daman and Diu", "Lakshadweep"];
	var selectedTax = option.listOfSalesTax.filter(function (ele) {
		return (ele.taxRate == option.rate) && (/gst/i.test(ele.taxName));
	});
	if (selectedTax.length) {
		var returnTax = {};
		if ((option.outlet && option.zone.stateIds.split(',').indexOf(option.outlet.state_id) == -1) || (option.state_id && option.zone.stateIds.split(',').indexOf(option.state_id + "") == -1)) {
			returnTax = selectedTax.filter(function (ele) {
				return /igst/i.test(ele.taxName);
			})[0];
		} else {
			var cgstTax = selectedTax.filter(function (ele) {
				return /cgst/i.test(ele.taxName);
			});
			if ((option.outlet && UTList.indexOf(option.outlet.state) == -1) || (option.state && UTList.indexOf(option.state) == -1)) {
				returnTax = cgstTax.filter(function (ele) {
					return /sgst(\s?|\s+)\+(\s?|\s+)cgst/i.test(ele.taxName);
				})[0];
			} else {
				returnTax = cgstTax.filter(function (ele) {
					return /utgst(\s?|\s+)\+(\s?|\s+)cgst/i.test(ele.taxName);
				})[0];
			}
		}
		return returnTax;
	}
};

export const getHighlightString = attrs => {
	var regToReplace = /(\]| |\[|\\|\(|\)|\+|\*|\.)/g,
		newString = attrs.searchKey.replace(/\s\s+/g, ' ').replace(/\?/g, ''),
		className = attrs.className || 'search-highlight';
	var array = [];
	if (newString) {
		array = newString.split(regToReplace);
		array = array.filter(function (ele) {
			return !regToReplace.test(ele);
		});
	}

	var textToMatch = attrs.searchResult || '';
	var reg = new RegExp(array.join('|'), 'gi');
	var searchedItems = textToMatch.match(reg);
	var replacedItems = [];
	if (searchedItems) {
		searchedItems.sort(function (a, b) {
			/* Sorting into descending order -
						The word having 1 or 2 characters length also matches within the bigger words
						issue: -
							How Can I assign

							How Can I assign
									^	 ^

					*/
			return a.length < b.length;
		});
		for (var i = 0; i < searchedItems.length; i++) {
			var curItem = searchedItems[i];
			if (curItem && replacedItems.indexOf(curItem) == -1) {
				replacedItems.push(curItem);
				let reg = new RegExp(curItem, 'gi');
				textToMatch = textToMatch.replace(reg, function (a, b) {
					return '@#$' + a + '$#@';
				});
			}
		}
		textToMatch = textToMatch.replace(
			/\@\#\$/g,
			"<span class='" + className + "'>"
		);
		textToMatch = textToMatch.replace(/\$\#\@/g, '</span>');
	}
	return textToMatch;
};

export const convertNumberToWords = amount => {
	var words = new Array();
	words[0] = '';
	words[1] = 'One';
	words[2] = 'Two';
	words[3] = 'Three';
	words[4] = 'Four';
	words[5] = 'Five';
	words[6] = 'Six';
	words[7] = 'Seven';
	words[8] = 'Eight';
	words[9] = 'Nine';
	words[10] = 'Ten';
	words[11] = 'Eleven';
	words[12] = 'Twelve';
	words[13] = 'Thirteen';
	words[14] = 'Fourteen';
	words[15] = 'Fifteen';
	words[16] = 'Sixteen';
	words[17] = 'Seventeen';
	words[18] = 'Eighteen';
	words[19] = 'Nineteen';
	words[20] = 'Twenty';
	words[30] = 'Thirty';
	words[40] = 'Forty';
	words[50] = 'Fifty';
	words[60] = 'Sixty';
	words[70] = 'Seventy';
	words[80] = 'Eighty';
	words[90] = 'Ninety';
	amount = amount.toString();
	var atemp = amount.split('.');
	var number = atemp[0].split(',').join('');
	var n_length = number.length;
	var words_string = '';
	if (n_length <= 9) {
		var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
		var received_n_array = new Array();
		for (var i = 0; i < n_length; i++) {
			received_n_array[i] = number.substr(i, 1);
		}
		for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
			n_array[i] = received_n_array[j];
		}
		for (var i = 0, j = 1; i < 9; i++, j++) {
			if (i == 0 || i == 2 || i == 4 || i == 7) {
				if (n_array[i] == 1) {
					n_array[j] = 10 + parseInt(n_array[j]);
					n_array[i] = 0;
				}
			}
		}
		var value = '';
		for (var i = 0; i < 9; i++) {
			if (i == 0 || i == 2 || i == 4 || i == 7) {
				value = n_array[i] * 10;
			} else {
				value = n_array[i];
			}
			if (value != 0) {
				words_string += words[value] + ' ';
			}
			if (
				(i == 1 && value != 0) ||
				(i == 0 && value != 0 && n_array[i + 1] == 0)
			) {
				words_string += 'Crores ';
			}
			if (
				(i == 3 && value != 0) ||
				(i == 2 && value != 0 && n_array[i + 1] == 0)
			) {
				words_string += 'Lakhs ';
			}
			if (
				(i == 5 && value != 0) ||
				(i == 4 && value != 0 && n_array[i + 1] == 0)
			) {
				words_string += 'Thousand ';
			}
			if (
				i == 6 &&
				value != 0 &&
				(n_array[i + 1] != 0 && n_array[i + 2] != 0)
			) {
				words_string += 'Hundred & ';
			} else if (i == 6 && value != 0) {
				words_string += 'Hundred ';
			}
		}
		words_string = words_string.split('  ').join(' ');
	}
	if (words_string != '') {
		return words_string + 'only';
	} else {
		return '';
	}
};

export const indNumberFormat = (num) => {
	num = num.toString();
	var afterPoint = '';
	if (num.indexOf('.') > 0)
		afterPoint = num.substring(num.indexOf('.'), num.length);
	num = Math.floor(num);
	num = num.toString();
	var lastThree = num.substring(num.length - 3);
	var otherNumbers = num.substring(0, num.length - 3);
	if (otherNumbers != '')
		lastThree = ',' + lastThree;
	var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
	return res;
}

export const Regex = {
	websiteRegex: /^((https?):\/\/)?(www.)?([a-zA-Z0-9]{2,})+\.[a-zA-Z0-9]+(\.?[a-zA-Z0-9]?)+\/?([a-zA-Z0-9#]+\/?)*$/,
	urlRegex: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,13}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
	priceRegex: /^\d{0,10}(\.\d{0,2})?$/,
	contentPerPcRegex: /^\d{0,6}(\.\d{0,3})?$/,
	minQtyRegex: /^\d{0,10}$/,
	skuRegex: /^[a-zA-Z0-9 _./\\-]*$/
};

export const bodyScrollHandler = (isStop) => {
	const overlyScrolHandler = ScrollHandlerService.getInstance();
	if (isStop) {
		overlyScrolHandler.stopScroll();
	} else {
		overlyScrolHandler.startScroll();
	}
}

const ScrollHandlerService = (function () {
	let instance;
	return {
		getInstance: function () {
			if (!instance) {
				instance = new ScrollHandler();
			}
			return instance;
		}
	};
})();

function ScrollHandler() {
	let count = 0;
	this.stopScroll = function (dataObj) {
		dataObj = dataObj || {};
		var deviceType = getDeviceType();
		dataObj.scrollingEle = dataObj.scrollingEle || window;
		this.scrollingEle = dataObj.scrollingEle;
		// this.classAdded = deviceType == 'WEB' ? 'stop-body-scroll' : 'stop-scrollWithPosFixed';
		this.classAdded = 'stop-body-scroll';
		if (this.scrollingEle) {
			var operatedEle = document.body;
			if (count == 0) {
				this.currentScrollTop = this.scrollingEle.pageYOffset;
				operatedEle.classList.add(this.classAdded);
			}
			count++;
		}
	}
	this.startScroll = function () {
		if (this.scrollingEle) {
			count--;
			if (count == 0) {
				document.body.classList.remove(this.classAdded);
			}
		}
	}
}

export const getDeviceType = function () {
	if (window && window?.webkit?.messageHandlers) {
		return 3;
	} else if (window && window.JdLiteInterface) {
		return 1;
	} else if (/(iPad|iPhone|iPod|CriOS)/g.test(navigator.userAgent)) {
		return 2;
	} else if (/mobile/i.test(navigator.userAgent)) {
		return 2;
	} else {
		return 7;
	}
}

export const autoLogout = async () => {
	const res = await axios.get("/marketplace/static/php/web/common_api.php?action=getAutoLoginUrl");
	const data = res.data;
	var onloadCount = 0;
	if (data.autoLogoutUrlList) {
		var logoutLinksArray = data.autoLogoutUrlList.split(",");
		for (var i = 0; i < logoutLinksArray.length; i++) {
			var logoutByImage = new Image();
			logoutByImage.src = logoutLinksArray[i];
			logoutByImage.style.visibility = "hidden";
			logoutByImage.style.position = "fixed";
			onloadCount += 1;
			logoutByImage.onload = automaticlogout;
			logoutByImage.onerror = automaticlogout;
			document.body.appendChild(logoutByImage);
		}
	}
	function automaticlogout() {
		onloadCount--;
		if (!onloadCount) {
			window.location.reload();
		}
	}
}

export const getMatchedUOM = (uomArr, uomVal) => {
	if(uomArr?.length) {
		for (let i = 0; i < uomArr.length; i++) {
			if (uomArr[i].val == uomVal || uomArr[i].displayVal == uomVal ||  uomVal?.toLowerCase()==uomArr[i].val?.toLowerCase() || 
				-1!==uomVal?.toLowerCase().indexOf(uomArr[i].displayVal?.toLowerCase())
			) {
				return uomArr[i];
			}
		}
	}
	return {};
}

export const generateBarcode = async (number) => {
	let barcodeData = await axios.get('/marketplace/inventory/ajax/service/getNewBarcode.service?count=' + (number || 1));
	return barcodeData;
}

export const generateSku = async (token) => {
	let skuData = await axios.get('/marketplace/static/php/web/b2bWebsite.php?action=getCountersPoTokenNew&token=' + (token));
	return skuData;
}

export const formatVendorData = (productArray) => {
	let newArray = []
	for (let i = 0; i < productArray.length; i++) {
		if (productArray[i]) {
			let details = {};
			details.productName = productArray[i].productName;
			details.productId = productArray[i].id;
			details.variantId = productArray[i].variantTable.variantId[0];
			details.imageUrl = productArray[i].variantTable.imageUrl[0];
			details.isTemplate = productArray[i].templateId > 0;
			details.variantCount = productArray[i].variantTable.variantId.length;
			details.sellingPrice = productArray[i].variantTable.price[0];
			details.minOrderQuantity = productArray[i].minOrderQuantity;
			details.uom = productArray[i].variantTable.unitOfMeasurement[0];
			details.type = "product";
			details.videoUrl = "{}";
			details.imageUrlArr = [];
			details.isSellOnline = productArray[i].isSellOnline;
			details.isReceiveEnquiry = productArray[i].isReceiveEnquiry;
			details.visibility = productArray[i].visibility == "OFF_DISPLAY" ? 'hide' : 'unhide';
			details.variantStatus = productArray[i].variant;
			details.minPrice = productArray[i].minPrice;
			details.maxPrice = productArray[i].maxPrice;
			details.enquiryPrice = productArray[i].enquiryPrice;
			details.activetab = productArray[i].activetab;
			details.netWeight = productArray[i].variantTable.contentPerPiece[0];
			details.netWeightUnit = productArray[i].variantTable.unitPerPiece[0];
			details.attachmentPresent = productArray[i].attachmentPresent;
			details.videoUrlIds = productArray[i].videoUrlIds || [];
			if (details.videoUrlIds && typeof details.videoUrlIds === 'string') {
				details.videoUrlIds = [parseInt(productArray[i].videoUrlIds)];
			}
			newArray.push(details);
		}
	}
	return newArray;
}
/**
 * This function is used for simple traverse if only Object and Key is passed otherwise, 
 * this function expects a tree object where it will decide whether to select unselect parent element.
 * @param {Object} object 
 * @param {String} key 
 * @param {Boolean} fetchParent 
 * @param {Object} options 
 */
export const travObjBrandCategory = (object = {}, key = '', fetchParent, options = {}) => {
	let temp = object, parent = object, itemKey;
	let { checkIsSelected, isSelected, curObjKey, childKey } = options;
	if (curObjKey) {
		key = curObjKey.split(".");
	} else {
		if (typeof key == "string") {
			key = key.split(".");
		} else {
			key = key[0].split(".");
		}
	}
	let parentCheck = [];
	/** Simple traverse loop */
	for (let i in key) {
		if (!temp) {
			return false;
		}
		if (i == (key.length - 2)) {
			parent = temp[key[i]];
		}
		temp = temp[key[i]];
		/** If the selected element is getting unselected then it checks whether to unselect parent or not by checking siblings of the selected element */
		if (childKey && !isSelected) {
			let childCheck = temp[childKey];
			if (childCheck && i != (key.length - 1) && Object.keys(childCheck).length) {
				let childSelected = false, selChildCount = 0;
				for (let [key1, value] of Object.entries(temp[childKey])) {
					if (value.is) {
						selChildCount++;
					}
				}
				/** if count is greater than one that means some other sibling is selected and parent above this node will not get deselected */
				if (selChildCount > 1) {
					childSelected = true;
				}
				/** push the result into an array, this will be later used to select or deselect subsequent parents */
				parentCheck.push({
					objRef: temp,
					childSelected
				});
			}
		}
		if (temp && checkIsSelected && (temp.ic || temp.ib)) {
			temp[checkIsSelected] = isSelected;
		}
		itemKey = key[i];
	}
	/** deselect all the parent until childSelected is found true */
	for (let i = parentCheck.length - 1; i >= 0; i--) {
		let revTravObj = parentCheck[i]
		if (!revTravObj.childSelected) {
			revTravObj.objRef.is = false;
		} else {
			break;
		}
	}
	if (fetchParent) {
		return {
			item: temp,
			itemKey,
			parent
		}
	} else {
		return temp;
	}
}

export const isValidURL = str => {
	let pattern = new RegExp(
		'^(https?:\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		'(\\#[-a-z\\d_]*)?$',
		'i'
	) // fragment locator
	return !!pattern.test(str)
}

export const productCatCapitalize = (text = '') => {
	// console.log('--b4--',text,'--after--',String(text)
    // .split(' ')
    // .map(word =>
    //   word.replace(/(^|\.)([a-zA-Z])/g, (match, prefix, char) =>
    //     prefix + char.toUpperCase()
    //   )
    // )
    // .join(' '));
	
  return String(text)
    .split(' ')
    .map(word =>
      word.replace(/(^|\.)([a-zA-Z])/g, (match, prefix, char) =>
        prefix + char.toUpperCase()
      )
    )
    .join(' ');
};


// export const productCatCapitalize = (catName = "") => {
// 	console.log('before',catName,'after',catName.replace(
//     /\w\S*/g,
//     (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(),
//   ));
	
	
// 	return catName.replace(
//     /\w\S*/g,
//     (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(),
//   );
// };

export const isValidImageURL = str => {
	str = (str.indexOf('http') == -1 ? 'http://' : '') + str;
	str = new URL(str);
	str.search = "";
	str = str.href;
	return str.match(/\.(jpeg|jpg|webp|png)$/i) !== null
}

export const logOut = (options = {}) => {
	let { token, cb } = options;
	axios.post(`/vendor/manage-products-genio/${token}/api/logout.ns`).then((data) => {
		cb && cb(data);
	});
};

export const fetchEnrichUrl = (options = {}) => {
	let session = getSessionStore();
	let { cb, queueType = '' } = options;
	let url = '';
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=fetchEnrichProduct&type=${queueType}`).then((data) => {
		const productId = data.data.results?.product_id;
		if(productId) {
			url = `/vendor/manage-products-genio/${session.token}/products/enrich/${productId}?queueType=${queueType}`;
		}
		cb && cb({url});
	});
};

export const rewriteUrlForLocal = (mainUrl) => {
	let returnUrl = mainUrl;
	if (process.env.NODE_ENV && process.env.NODE_ENV == 'dev') {
		if(mainUrl.toLowerCase().indexOf(config.B2B_URL.toLowerCase())!==-1) {
			returnUrl = mainUrl.replace(config.B2B_URL, window.location.protocol+'//'+config.auditorDomain);
		} else {
			returnUrl = mainUrl.replace(config.serverApiDomain, window.location.protocol+'//'+config.auditorDomain);    
		}                        
	}
	return returnUrl;
}

export const fetchAuditUrl = (options = {}) => {
	let { cb, queueType = '' } = options;
	let search = identifyAuditFlow({ query: true });
	if (!queueType && search.queueType) {
		queueType = search.queueType;
	}
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=fetchProduct&queueType=${queueType}`).then((data) => {
		if (data.data.url && queueType) {
			if (data.data.url.indexOf("?") != -1) {
				data.data.url += `&queueType=${queueType}`;
				data.data.url = rewriteUrlForLocal(data.data.url);
			} else {
				data.data.url += `?queueType=${queueType}`;
			}
			if (search.isObjection) {
				data.data.url += `&isObjection=true`;
			}
		}
		cb && cb(data);
	});
};

export const checkProductStatus = (options = {}) => {
	let { token, productId, cb, timeStamp } = options;
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=checkAuditStatus&token=${token}&variantId=${productId}&timestamp=${encodeURIComponent(timeStamp)}`).then((data) => {
		cb && cb(data);
	});
};

export const skipProduct = (options = {}) => {
	let { token, productId, cb, queueType, id,consignmentNo } = options;
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=skipAuditProduct&token=${token}&variantId=${productId}${id ? `&id=${id}`: ''}${queueType ? `&queueType=${queueType}` : ''}${consignmentNo ? `&consignmentNo=${consignmentNo}`: ''}`).then((data) => {
		cb && cb(data);
	});
};

export const skipEnrichProduct = (options = {}) => {
	let {productId, cb} = options;
	axios.get(`/vendorapis/contractor/contractor/skipContractorProduct?productId=${productId}`).then((data) => {
		cb && cb(data);
	});
};

export const deleteObjectionableProduct = (options = {}) => {
	let { token, id, queueType, cb } = options;
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=rejectObjectionableProduct&token=${token}&id=${id}&queueType=${queueType}`).then((data) => {
		cb && cb(data);
	});
};

export const checkForCameraPermissions = () => {
	try {
		if (window.webkit && window.webkit.messageHandlers['callbackHandler']) {
			window.webkit.messageHandlers['callbackHandler'].postMessage(
				JSON.stringify({ type: 'cameraPermissions' })
			)
		} else if (window.JdLiteInterface) {
			window.JdLiteInterface.getCameraPermission(
				JSON.stringify({ fn: 'uploadImagePermission' })
			)
		}
	} catch (e) {
		console.log(e)
	}
}

export const addCaptureFlag = () => {
	return typeof window != 'undefined' && (window.wap == 21 || window.source == 21)
}

export const auditSearch = (options = {}) => {
	let { searchBy, productId, city, showResultBy, searchEmployeeBy, docId, employeeId, employeeMobile, lastModifiedFrom, lastModifiedTo, cb, pageNo } = options;
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=searchAuditProductForMarketplace${searchBy ? `&searchBy=${encodeURIComponent(searchBy)}` : ''}
			${productId ? `&productId=${encodeURIComponent(productId)}` : ``}${city ? `&city=${encodeURIComponent(city)}` : ''}${showResultBy ? `&showResultBy=${encodeURIComponent(showResultBy)}` : ''}
			${searchEmployeeBy ? `&searchEmployeeBy=${encodeURIComponent(searchEmployeeBy)}` : ''}${docId ? `&docId=${encodeURIComponent(docId)}` : ''}${employeeId ? `&employeeId=${encodeURIComponent(employeeId)}` : ''}
			${employeeMobile ? `&employeeMobile=${encodeURIComponent(employeeMobile)}` : ''}${lastModifiedFrom ? `&lastModifiedFrom=${encodeURIComponent(lastModifiedFrom)}` : ''}
			${lastModifiedTo ? `&lastModifiedTo=${encodeURIComponent(lastModifiedTo)}` : ''}&pageNo=${pageNo ? `${encodeURIComponent(pageNo)}` : 1}`)
		.then((data) => {
			cb && cb(data);
		});
};

export const getAuditProductUrl = (options = {}) => {
	let { productId, searchBy, id, cb } = options;
	axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=searchAuditProductForMarketplace&searchBy=${searchBy ? searchBy : "productId"}${id ? `&Id=${id}` : `&productId=${productId}`}`).then((data) => {
		cb && cb(data);
	});
};

const INVALID_PRODUCT_NAMES = [
	"http",
	"\\?",
	">",
	"<",
	"#",
	// "\\+",
	"…",
	// "Near",
	"More Info",
	"Get best",
	"Call for",
	"Contact us",
	"Request",
	"Find a Contact",
	"Third Party",
	"Whatsapp",
	"Whtsapp",
	"Indiamart",
	"India mart",
	"Tradeindia",
	"Trade india",
	"Alibaba",
	"Manufacturers in",
	"Dealers in",
	"Importers in",
	"Exporters in",
	"About",
	"How to",
	"\\\\",
	"\\.\\.",
	"%20",
	"dealer",
	// "dealing",
	"exporter",
	// "exporting",
	"importer",
	// "importing",
	// "manufacture",
	"manufacturer",
	// "manufacturing",
	// "retail",
	// "retailing",
	"stockist",
	"wholesaler",
	// "wholeselling",
	// "wholesaling",
	"Contact Number",
	"\\*",
	"~",
	"`",
	"\\^",
	"Phone Number",
	"Call Me"
]


const INVALID_PRODUCT_NAMES_REGEX = new RegExp(INVALID_PRODUCT_NAMES.join('|'), 'gi');

export const isProductNameValid = (productName = "") => {
	let invalidMatch = true;
	const matchArray = productName.match(/[a-z]/ig);
	if (matchArray && matchArray.length >= 3) {
		invalidMatch = productName.match(INVALID_PRODUCT_NAMES_REGEX);
	}
	return !invalidMatch;
}

export const parseCatData = data => {
	if (data) {
		let categories = [];
		let arr = data.split("\u00C7");
		for (let i = 0; i < arr.length; i++) {
			categories.push(getCatData(arr[i]));
		}
		return categories;
	}
	return [];
};

const getCatData = str => {
	let tempCat = str.split("\u00c8")[0],
		separatorIndex = tempCat.lastIndexOf("_"),
		id = tempCat.substring(separatorIndex + 1, tempCat.length), // store the id of the category.
		name = tempCat.substring(0, separatorIndex);
	let lastSeperator = name.lastIndexOf(">");
	let leafNode = name.substring(lastSeperator + 1); //retrieving the leaf node
	let nodesArray = name.split(">>");
	let categoryBreadcrumb = nodesArray
		.slice(Math.max(nodesArray.length - 2, 0))
		.join(">>");
	return {
		catName: leafNode,
		id: id,
		categoryBreadcrumb: name
	};
};

export const getRelevantCategory = (data) => {
	data.map(function (item) {
		let categoryBreadCrumbs = item.categoryPath.split(">>");
		item.catName = categoryBreadCrumbs[categoryBreadCrumbs.length - 1];
		item.id = item.puvId;
	});
	return data;
}

export const getItemImagesFromVendor = (data) => {
	let result = [];
	for (let i = 1; i < 41; i++) {
		if (data['productImage' + i]) {
			let imageData = {
				finalImageSrc: data['productImage' + i].includes('http') ? data['productImage' + i] : staticImageDomains + '/product' + data['productImage' + i],
				imageUrl: data['productImage' + i]
			}
			result.push(imageData);
		}
	}
	return result;
}

//Set Toast Message on Route Change
export const setRouteChangeMessage = (msg) => {
	if (window?.localStorage){
		window.localStorage?.setItem("showToastMessage", JSON.stringify(msg));
	}
}

export const getRouteChangeMessage = () => {
	let msg = ''
	try{
		if (window?.localStorage){
			msg = JSON.parse(window.localStorage?.getItem('showToastMessage'));
			window.localStorage?.removeItem('showToastMessage');
		}
	}catch(err){
		console.log("Error is ",err.message);
		msg = ""
	}
	return msg;
}

export const scrollIntoView = (element, className = 'add-edit-container') => {
	let isKeyPadOpen = (window.screen.height - window.innerHeight > 240);
	if (!isKeyPadOpen) {
		var pgContainer = document.getElementsByClassName(className)[0];
		var curScroll = pgContainer.scrollTop;
		var distanceFromBottom = window.innerHeight - element.getBoundingClientRect().bottom;
		let keypadHeight = 240;//TODO
		if ((distanceFromBottom - 60) < keypadHeight) {
			var threshHold = keypadHeight - distanceFromBottom;//60 for footer button
			setTimeout(() => {
				if (document.getElementsByClassName(className)[0]) {
					document.getElementsByClassName(className)[0].scrollTo({
						top: (curScroll + threshHold + 60),
						behavior: 'smooth',
					});
				}
			}, 400);
		}
	} else {
		element.scrollIntoView({ behavior: "smooth", block: 'center' })
	}
}

export const onBackClick = (isEdit, redirectedFrom) => {
	let params = new URLSearchParams(location.search.substring(1));
	let source = params.get("source");
	let query = params.get("query");
	let urlsource = params.get("urlsource");
	let fromWalkthrough = params.get("fromWalkthrough");
	if (JSON.parse(window.localStorage.getItem('quickstart'))) {
		window.localStorage.removeItem('quickstart');
		window.location.href = '/myaccount/quickstart';
		return;
	} else if (JSON.parse(window.localStorage.getItem('categoryListing'))) {
		window.localStorage.removeItem('categoryListing');
		if (isEdit) {
			window.history.back();
		} else {
			window.history.go(-3);
		}
		return;
	} else if (source && source != "/myaccount/vendor/search") {
		window.location.href = source;
		return;
	} else if (urlsource && redirectedFrom != 'listing') {
		// if(urlsource == '/' || urlsource.indexOf('/search?srchval') != -1)
		window.location.replace(urlsource);
	} else if (isEdit && redirectedFrom == 'listing') {
		window.history.back();
	} else if (redirectedFrom == 'listing') {
		window.history.go(-2);
	} else if (redirectedFrom == 'photos') {
		window.history.back();
	} else {
		window.location.href = '/myaccount/products';
	}
}

export const identifyAuditFlow = (options = {}) => {
	let response = {};
	if (typeof window !== 'undefined') {
		let { query, checkType } = options;
		let search = window.location.search;
		search = queryString.parse(search);
		response = search;
		if (query) {
			return response;
		}
		if (checkType) {
			response = {};
			if (search.isAuditUrl) {
				response.fetchNextAudit = true;
			}
			if (search.useAuditApi) {
				response.searchAudit = true;
			}
			if (search.isSpecialContract) {
				response.isSpecialContract = true;
			}
			if (search.isObjection) {
				response.isObjectionable = true;
			}
			if (search.isBrandedProd) {
				response.isBrandedProd = true;
			}
		}
	}
	return response;
};

export const enforceStrictASCII = (str = "") => {
  let result = "";

  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    const code = char.charCodeAt(0);

    const isASCII = code <= 127;

    if (isASCII) {
      result += char;
    } else {
      const prev = str[i - 1];

      if (
        prev &&
        prev.charCodeAt(0) <= 127 &&
        result[result.length - 1] !== " "
      ) {
        result += " ";
      }
    }
  }

  return result;
};

const blackListHTM = [
	"!doctype","acronym","applet","area","aside","basefont","base",
	"bdo","bgsound","big","blink","body","button","canvas","center",
	"cite","code","command","content","datalist","details","dialog",
	"dir","embed","eventsource","fieldset","font","footer","form","frameset",
	"frame","header","hgroup","html","iframe","image","input","ins","isindex",
	"keygen","label","legend","link","map","marquee","menuitem","menu","meta","meter",
	"nav","nobr","noembed","noframes","noscript","object","optgroup","option","output","param","picture",
	"plaintext","portal","progress","rb","rp","rtc","rt","ruby","select","shadow","slot",
	"source","spacer","strike","summary","template","textarea","title","tt","var","xmp","script","style"
];

const trimBlacklist = (value,ele) => {
	let result = "";
	let firstOccurance = value.indexOf('<' + ele);
	result = value.substring(0, firstOccurance);
	const firstClosingTag = value.indexOf('</' + ele + '>');
	if (firstClosingTag != -1) {
		let secondOccurance = -1;
		do {
			secondOccurance = value.indexOf('<' + ele, (firstOccurance + ele.length + 2));
			if(secondOccurance!=-1 && secondOccurance < firstClosingTag) {
				firstOccurance=secondOccurance;
				result = value.substring(0, firstOccurance);
			}
		} while(secondOccurance!=-1 && secondOccurance < firstClosingTag); 
		result += value.substring(firstClosingTag + ele.length + 3, value.length);
	} else if (firstOccurance != -1) {
		var tmp = value.substring(firstOccurance, value.length);
		result += tmp.substring(tmp.indexOf('>') + 1, tmp.length);
	}
	if(result.includes('<'+ele)){
		return trimBlacklist(result,ele);
	}
	return result;
}
export const formatProdDesc = (value, saveFlow = false) => {
	value = value.replace(/&lt;/g, "<");
	value = value.replace(/&gt;/g, ">");
	value = value.replace(/&nbsp;/gi," ");
	value = value.replace(/\r?\n|\r/g, " ");
	value = value.replace(/\s+/g,' ');
	// const doc = new DOMParser().parseFromString(value, "text/html");
	// const HTMLArray = [...doc.body.children].map(el => el.innerHTML);
	let resultStr = value;
	blackListHTM.map(cur => {
		var isFound = resultStr.includes('<'+cur);
		if(isFound){
			resultStr = trimBlacklist(resultStr,cur);
		}
	})
	// HTMLArray.map(cur => {
	// 	let acceptable = true;
	// 	for(let index = 0; index < blackListHTM.length; index ++){
	// 		if(cur.toLocaleLowerCase().indexOf('<'+blackListHTM[index]) != -1){
	// 			acceptable = false;
	// 			break;
	// 		}
	// 	}
	// 	if(acceptable){
	// 		resultStr += cur;
	// 	}
	// })
	// console.log('value === > ', value);
	// console.log('resultStr ==> ', resultStr)
	// value = resultStr.replace(/<script.*>.*<\/script>/ims, " ")
	value = resultStr.replace(/(<\?php).*\?>/ims, " ")
	value = value.replace(/\s+on\w+=(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
	value = value.replace(/(<.*?)(novalidate=.*?)(>)/ig,"$1$3");
	value = value.replace(/(<.*?)(style=.*?)(>)/ig,"$1$3");
	// value = resultStr.replace(/(<.*?)(on.*?=['"].*?['"]|style=['"].*?['"].?)(\s*?>)/ig,"$1$3")
	// console.log('value: replace : ', resultStr);

	var elementsToRemove = [];
	function removeNodes(allNodes) {
		for (var i = 0; i < allNodes.length; i++) {
			var curNode = allNodes[i];
			if(curNode.textContent && curNode.textContent.trim()){
				if(curNode.childElementCount){
					removeNodes(curNode.children);
				}
				return true;
			} else if (['p'].indexOf(curNode.tagName.toLowerCase()) != -1) {
				elementsToRemove.push(curNode)
			} else if (curNode.childElementCount) {
				var flag = removeNodes(curNode.children);
				if (flag) {
					return true;
				}
			}

		}
	}

	document.body.insertAdjacentHTML('beforeend', '<div class="description-space-helper" style="display:none">' + value + '</div>');
	const parentDOM = document.querySelector(".description-space-helper")
	removeNodes(parentDOM.children);

	for(var i = elementsToRemove.length-1;i>=0;i--){
		elementsToRemove[i].remove();
	}

	value = parentDOM.innerHTML;
	parentDOM.remove();
	return value;
}

export const setPackagePermissionData = (packageId) => {
	const deviceType = getStore().getState().deviceData.isMobile ? 'mobile' : 'web';
	return axios.get("/marketplace/getPackageDetail.ns?id=" + packageId + "&deviceType=" + deviceType);
}

export const getPackagePermission = (strKey, type) => {
	if (!strKey) {
		return true;
	}
	const packagePermissionData = getStore().getState().permissions.packagePermissionData;
	var isVisible = true;
	var value = strKey;
	var keyArr = value.split('.'),
	objKey = packagePermissionData;
	objKey = packagePermissionData.packageDetails;
	for (var i = 0; i < keyArr.length; i++) {
		objKey = objKey[keyArr[i]];
		//value = objKey[keyArr[i]];
	}

	if(type === "FEATURE_INFO"){
		return objKey;
	}

	if(objKey && objKey.status == 'HIDDEN'){
		isVisible = false;
	}

	return isVisible;
}
const replaceAll = (options = {}) => {
	const {
		value = '',
		split,
		replace
	} = options;
	return value.split(split).join(replace);
};
export const objectionalKeyHandling = (options = {}) => {
	let {
		key = 'CHECK',
		value = '',
		id
	} = options;
	const objectKey = `_${id}_OBJECTION`;
	value = value + '';
	if (key == 'CHECK') {
		return value.indexOf('_OBJECTION') != -1 ? true : false;
	} else if (key == 'ADD') {
		return value + objectKey;
	} else if (key == 'REPLACE') {
		return replaceAll({
			value,
			split: objectKey,
			replace: ''
		});
	}
};
export const getAuditTagValues = (options = {}) => {
	console.log('getAuditTagValues options',options);
	
	const { type } = options;
	const auditTagValues = {
		contractor: {
			productTag: "CONTRACTOR V1 LTBM AUDIT QUEUE",
			tagColor: 	"orange"
		},
		contractorServiceQueue: {
			productTag: "CONTRACTOR V1 LTBM AUDIT QUEUE",
			tagColor: 	"orange"
		},
		regular: {
			productTag: "REGULAR AUDIT QUEUE",
			tagColor:	"green"
		},
		furlough: {
			productTag: "FURLOUGH AUDIT QUEUE",
			tagColor:	"orange"
		},
		dbQueue: {
			productTag: "DB AUDIT QUEUE",
			tagColor:	"orange"
		},
		onboardQueue: {
			productTag: "ONBOARDING AUDIT QUEUE",
			tagColor:	"orange"
		},
		objectionFree: {
			productTag: "NON-PAID OBJECTIONABLE PRODUCT AUDIT QUEUE",
			tagColor:	"orange"
		},
		objectionPaid: {
			productTag: "PAID OBJECTIONABLE PRODUCT AUDIT QUEUE",
			tagColor:	"orange"
		},
		contractorv2: {
			productTag: "CONTRACTOR V2 LTBM AUDIT QUEUE",
			tagColor:	"orange"
		},
		contractorv2ServiceQueue: {
			productTag: "CONTRACTOR V2 LTBM AUDIT QUEUE",
			tagColor:	"orange"
		},
		contractorv3: {
			productTag: "CONTRACTOR  V3 AUDIT QUEUE",
			tagColor:	"orange"
		},
		/*branded: {
			productTag:	"BRANDED PRODUCT AUDIT QUEUE",
			tagColor:	"orange"
		},
		marketplace: {
			productTag: "MARKETPLACE AUDIT QUEUE",
			tagColor:	"green"
		},
		brandedMrp: {
			productTag:	"MRP COMPLIANCE QUEUE",
			tagColor:	"orange"
		},
		*/
		regularService: {
			productTag:	"REGULAR SERVICE AUDIT QUEUE",
			tagColor:	"green"
		},
		restrictedService: {
			productTag:	"RESTRICTED SERVICE AUDIT QUEUE",
			tagColor:	"red"
		},
		objectionableService: {
			productTag:	"PAID OBJECTIONABLE SERVICE AUDIT QUEUE",
			tagColor:	"orange"
		},
		nonpaidObjectionalService: {
			productTag: "NON-PAID OBJECTIONABLE SERVICE AUDIT QUEUE",
			tagColor: "orange"
		},
		onboardEmpQueue: {
			productTag:	"ONBOARDING EMPLOYEE AUDIT QUEUE",
			tagColor:	"orange"
		},
		onboardEmpServiceQueue: {
			productTag:	"ONBOARDING EMPLOYEE AUDIT QUEUE",
			tagColor:	"orange"
		},
		nonRelevanceQueue:{
			productTag: "Owner LTBM PRODUCT AUDIT QUEUE",
			tagColor: "orange"
		},
		nonRelevanceServiceQueue: {
			productTag: "Owner LTBM SERVICE AUDIT QUEUE",
			tagColor: "orange"
		}

	}
	
	if (type && auditTagValues[type]) {		
		return auditTagValues[type];
	} else {
		return {
			productTag: "",
			tagColor: 	""
		};	
	}	
	
};
export let initializeStore = {
	set: function (key, options) {
		if (typeof (sessionStorage) != 'undefined' && sessionStorage) {
			sessionStorage.setItem(key, JSON.stringify(options));
		} else if (typeof (localStorage) != 'undefined' && localStorage) {
			localStorage.setItem(key, JSON.stringify(options));
		}
	},
	get: function (key) {
		if (typeof (sessionStorage) != 'undefined' && sessionStorage) {			
			return JSON.parse(sessionStorage?.getItem(key) || '""');
		} else if (typeof (localStorage) != 'undefined' && localStorage) {
			return JSON.parse(localStorage?.getItem(key) || '""');
		}
	},
	remove: function (key) {
		if (typeof (sessionStorage) != 'undefined' && sessionStorage) {
			sessionStorage.removeItem(key);
		} else if (typeof (localStorage) != 'undefined' && localStorage) {
			localStorage.removeItem(key);
		}
	}
};

export const setJdMartParams = (removeParams) => {
	if (removeParams) {
		if (initializeStore.get('sourceId')) {
			initializeStore.remove('sourceId');
		}
	} else {
		let response = {};
		if (typeof window !== 'undefined') {
			let search = window.location.search;
			response = queryString.parse(search);
		}
		if (response.p) {
			initializeStore.set('sourceId', response.p);
		}
	}
}

export const getJdMartParams = () => {
	let response = {
		sourceId: '',
	};
	response.sourceId = initializeStore.get('sourceId');
	return response;
};

export const escapeRegExp = (value = '') => {
	return value.replace(excapeRegex, '\\$&');
}

export const getBusinessTypes = (growerFlag = false,developerFlag = false) => {
	return [
		{
			bizType: 'Retailer',
			natCatId: 'Retailer',
			hide: false,
		},
		{
			bizType: 'Wholesaler',
			natCatId: 'Wholesaler',
			hide: false
		},
		{
			bizType: 'Distributor',
			natCatId: 'Distributor',
			hide: false
		},
		{
			bizType: 'Exporter',
			natCatId: 'Exporter',
			hide: false
		},
		{
			bizType: 'Importer',
			natCatId: 'Importer',
			hide: false
		},
		{
			bizType: 'Manufacturer',
			natCatId: 'Manufacturer',
			hide: growerFlag || developerFlag
		},
		{
			bizType: 'Grower',
			natCatId: 'Grower',
			hide: !growerFlag
		},
		{
			bizType: 'Developer',
			natCatId: 'Developer',
			hide: !developerFlag
		}
	]
};

export const checkForTrailingZeroes = (num) => {
	let trailingZeroes = num.endsWith('.00');
	if (trailingZeroes) {
		return Number(num);
	}
	return num;
}

export const getTimeDiff = (dateVal,options = {})=>{
    let diffTime = '';
    let standalone = window.navigator.standalone,
        userAgentApp = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test( userAgentApp ),
        ios = /iphone|ipod|ipad/.test( userAgentApp );
    let isIosApp = false;
    if(ios && !standalone && !safari){
        isIosApp = true;
    }
    if (dateVal) {
        if ((navigator.userAgent.indexOf("Safari") == -1) && dateVal.indexOf('T') && !isIosApp) {
            dateVal += '+0530';
        }
        let currentDate = new Date(), dateValue = new Date(dateVal);
        let timeDiff = dateValue.getTime() - currentDate.getTime();
        if(options.onlyDiff){
            return timeDiff/60000;
        }
        if (options.onlyPositive === '+') {
            diffTime = Math.abs(diffTime);
        }
        timeDiff = timeDiff / 1000;
        let hour = Math.abs(Math.floor(timeDiff / 3600));

		if (hour > 24) {
			diffTime = Math.floor(hour / 24);
			diffTime += diffTime == 1 ? ' Day' : ' Days';
		}
		else {
			let hoursStr = hour == 1 ? ' Hour' : ' Hours';
			if (options.withMinuts) {
				let min = 0;
				min = Math.floor((timeDiff % 3600) / 60);
				min = ':' + (min <= 9 ? '0' + min : min);
				hour = hour <= 9 ? '0' + hour : hour;
				diffTime = hour + min + hoursStr;
			} else {
				if (hour > 1) {
					diffTime = hour + hoursStr;
				} else {
					diffTime = Math.abs(Math.floor(timeDiff / 60)) + " Mins";
				}
			}
		}
	}
	return diffTime;
}


export const getTimeString = (options = {}) => {
	let timeString = '';
	let data = options.timeData;
	if (data instanceof Date) {
		let timeValue = {
			hours: ((data).getHours()) % 12 == 0 ? 12 : ((data).getHours()) % 12,
			minutes: ((data).getMinutes() > 10) ? (data).getMinutes() : '0' + (data).getMinutes(),
			time: ((data).getHours() > 11) ? 'PM' : 'AM'
		}
		timeString = timeValue.hours + ":" + timeValue.minutes + " " + timeValue.time;
	} else if (data instanceof Object) {
		let am_pm = data.hours >= 12 ? "PM" : "AM";
		let hour_display = (data.hours % 12) == 0 ? 12 : data.hours % 12;
		let minute_display = (data.minutes < 10) ? '0' + data.minutes : data.minutes;
		timeString = hour_display + ":" + minute_display + " " + am_pm;
	}
	return timeString;
}

export const getTimeSlots = (date,options = {})=>{
    let currentDate = date ? new Date(date):new Date();

    let startTime = {
        hours: Number(currentDate.getHours()),
        minutes : Number(currentDate.getMinutes())
    }

	let endTime = {
		hours: 24,
		minutes: 0
	}

	let timeSlotDifference = 15;
	let timeSlotArray = [];
    for(let counterIndex = startTime.hours; counterIndex < endTime.hours;){
        if(startTime.minutes % 5 != 0){
            if(options.from == 'discount'){
                startTime.minutes = Math.ceil(startTime.minutes / 5) * 5;
            }else{
                //#323647 Vendor: Prefilled time should be 15 mins ahead of the current time in self pick up and in home delivery time section (web).
                startTime.minutes = Math.ceil(startTime.minutes / 5) * 5;
            }
        }
        if(startTime.minutes > 0 && startTime.minutes <= 15){
            startTime.minutes = 15;
        }else if(startTime.minutes >15 && startTime.minutes <= 30){
            startTime.minutes = 30;
        }else if(startTime.minutes >30 && startTime.minutes <= 45){
            startTime.minutes = 45;
        }else if(startTime.minutes >45){
            startTime.minutes = 0;
            startTime.hours = startTime.hours + 1;
        }
        if(startTime.minutes >= 60){
            let minutes = (startTime.minutes)%60;
            let extraHour = Math.floor(startTime.minutes/60);
            startTime.minutes = minutes;
            startTime.hours = startTime.hours + extraHour;
        }
        let am_pm = startTime.hours >= 12 && startTime.hours != 24 ? "PM" : "AM";
        let hour_display = (startTime.hours % 12) == 0 ? 12 : startTime.hours % 12;
        let minute_display = (startTime.minutes < 10) ? '0'+startTime.minutes : startTime.minutes;
        counterIndex = startTime.hours;
        if(startTime.hours != 24){
            timeSlotArray.push({
                label : hour_display+":"+minute_display + " "+am_pm,
                key : hour_display+":"+minute_display + " "+am_pm
            })
        }
        startTime.minutes = startTime.minutes + timeSlotDifference;
    }
    options.cb && options.cb(timeSlotArray)
}

export const getBrandAppliedList = (data, type, option) => {
	if (type == 'brand') {
		let brandIds = [];
		data.map(item => {
			if (option == 'ALL') {
				brandIds.push(item.ALL);
			} else {
				Object.values(item).map(cur => {
					brandIds.push(cur);
				});
			}
		});
		let uniqueBrands = new Set(brandIds);
		uniqueBrands = [...uniqueBrands];
		return uniqueBrands;
	} else {
		return data
	}
};

const pretify = (val) => {
	return `${val}`.length > 1 ? val : `0${val}`;
};

export const getDisplayDate = (date = '') =>{
	var date1 = date ? new Date(date.replace(/-/g, '/')) : new Date();
	var timeHrs = date1.getHours();
	timeHrs = timeHrs == 0 ? 12 : timeHrs;
	var timeMins = date1.getMinutes();
	var hrs = pretify(timeHrs > 12 ? timeHrs - 12 : timeHrs);
	var mins = pretify(timeMins);
	var ampm = timeHrs < 12 ? "AM" : "PM"
	date1.setHours(0, 0, 0, 0);

	var date2 = new Date();
	date2.setHours(0, 0, 0, 0);

	var timeDiff = Math.abs(date1.getTime() - date2.getTime());
	var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
	var dayLabel = "";
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
	];
	if (diffDays == 1 && date2 < date1) {
		dayLabel = "Tomorrow";
	} else if (!diffDays) {
		dayLabel = "Today";
	} else {
		dayLabel = 'on ' + date1.getDate() + " " + monthNames[date1.getMonth()];
	}

	dayLabel += ', ' + hrs + ':' + mins + ' ' + ampm;
	return dayLabel;
}

export const getRemainingTime = (dateStr = '') => {
	const total = dateStr - new Date();
	// const totalDays = Math.floor(Math.abs(total) / (1000 * 60 * 60 * 24));
	const totalHours = Math.floor(Math.abs(total) / (1000 * 60 * 60));
	const totalMinutes = Math.abs(total) / (1000 * 60);
	// const seconds = Math.floor((Math.abs(total) / 1000) % 60);
	const minutes = Math.floor((Math.abs(total) / 1000 / 60) % 60);
	const hours = Math.floor(((Math.abs(total) / 1000) * 60 * 60) % 24);
	let timer = "";
	const extraDay = Math.floor(totalHours / 24);
	if (totalMinutes / 60 > 1 && totalMinutes / 60 < 24) {
		timer = `${pretify(hours)} Hr(s)`;
	} else if (totalMinutes / 60 < 1) {
		timer = `${pretify(minutes)} Min(s)`;
	}
	return extraDay == 0 ? timer : extraDay + " Day(s)";
}

export function getDateLabel(dateStr) {
	//Mon Dec 27 2021 13:20:42 GMT+0530 (India Standard Time)
	const arr = dateStr.split(" ");
	const time = arr[4].split(":");
	const [hr, min] = [time[0], time[1]];
	const twelveHrTime = hr > 12 ? `${Number(hr) - 12}:${min} PM` : `${hr}:${min} AM`;
	return `${twelveHrTime}, ${arr[0]}, ${arr[2]} ${arr[1]} '${arr[3].slice(2)}`;
}

export function getDeliveredOnDateLabel(dateStr) {
	//Mon Dec 27 2021 13:20:42 GMT+0530 (India Standard Time)
	const arr = dateStr.split(" ");
	const time = arr[4].split(":");
	const [hr, min] = [time[0], time[1]];
	const twelveHrTime = hr > 12 ? `${Number(hr) - 12}:${min} PM` : `${hr}:${min} AM`;
	return `${arr[0]}, ${arr[2]} ${arr[1]} '${arr[3].slice(2)},${twelveHrTime}`;
}

export function getFormatedDate(dateStr) {
	const dateFormatRegex = /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/;
	const dateArray = dateFormatRegex.exec(dateStr);
	const dateObject = new Date(
		+dateArray[1],
		+dateArray[2] - 1,
		+dateArray[3],
		+dateArray[4],
		+dateArray[5],
		+dateArray[6]
	);
	return dateObject;
}

export const isToday = date => {
	const today = new Date();
	return (
		date.getDate() === today.getDate() &&
		date.getMonth() === today.getMonth() &&
		date.getFullYear() === today.getFullYear()
	);
};

export const isYesturday = date => {
	const today = new Date();
	return (
		date.getDate() === today.getDate() - 1 &&
		date.getMonth() === today.getMonth() &&
		date.getFullYear() === today.getFullYear()
	);
};

export function isSafari() {
	let userAgentApp = window.navigator.userAgent.toLowerCase();
	let safari = /safari/.test(userAgentApp);
	let chromeAgent = /chrome/.test(userAgentApp);
	if (safari && !chromeAgent) {
		return true;
	}
	return false;
}

export const checkBasedOnSource = (source,finishCB=()=>{}) => {
	let userInfo = {};
	switch (source) {
		/**Android */
		case 1:
		case 21:
		case 51:
			if (window.JdLiteInterface) {
				var logjson = window.JdLiteInterface.getLoginData();
				if (logjson && logjson != '') {
					var logresponse = JSON.parse(logjson);
					userInfo = {
						mobile:logresponse.mobile,
						source,
						sid:logresponse.sid,
						deviceId:logresponse.device_details.deviceid,
						version :logresponse.devicebuildversion,
					}
					return userInfo;
				}else{
					redirectToLogin(window.location.href, source);
					return userInfo;
				}
			};
			return userInfo;
			break;

		/**IOS */
		case 3:
		case 23:
		case 53:
			console.log("entered checkBasedSource")
			window.getLoginData = (res)=>{
				getLoginData(res);
				finishCB()
			}
			var logjson = JSON.stringify({'type':'verticalLogin','fn':'getLoginData'});
			window?.webkit?.messageHandlers?.callbackHandler?.postMessage(logjson);
			console.log("exit checkbasedSource")
			
			return userInfo;
			break;

		/**Touch */
		case 2:
		case 22:
		case 52:
			if (source==2) {
				redirectToLogin(window.location.href, source);
				return userInfo;
			}
			userInfo = {				
				mobile: getCookie("mobile") || getQueryParam('mobile'),
			}			
			return userInfo;
			break;

		/**Website */
		case 7:   /* old website version */
		case 27:
		case 57:
		case 77: /* new website version */		
			if (source==7) {
				redirectToLogin(window.location.href, source);
				return userInfo;
			}
			userInfo = {
				mobile: getCookie("mobile") || getQueryParam('mobile'),
			}
			return userInfo;
			break;

		case 14:
			userInfo = {
				mobile: getCookie("mobile") || getQueryParam('mobile'),
			}
			return userInfo;
			break;
		
		default:
			console.log("default case executed");
			const sidCookie = getCookie("sid");
			const isFromWhatsapp = getQueryParam('utm_source') == "whatsapp";
			const isCampagin = getQueryParam('wts') == "1";
			if(!sidCookie && source == "" && isCampagin){
				redirectToLogin(window.location.href, source);
				return userInfo;
			}
			if (!sidCookie && isFromWhatsapp) {
				redirectToLogin(window.location.href, source);
				return userInfo;
			} else {
				return {
					mobile: getCookie("mobile") || getQueryParam('mobile'),
					source,
					sid:getCookie("sid"),
					deviceId:getCookie("_ctok") || getCookie("deviceId") || getCookie("deviceid"),
				};
			}
			break;

	}
}

export const setCurrentDeviceDetails = async (token) => {
	return new Promise((resolve)=>{
		if (window) {
			console.log("entered setCurrentDeviceDetails fn");
			let source = Number(getQueryParam('source'));
			if(isNaN(source)){
				// if it has multiple source param in url ex: source=1&source=2
				// for that considering last source param - source=2
				source = new URLSearchParams(window.location.search)?.getAll("source")?.slice(-1)?.[0]
				// if it has comma separated value in source Ex: source=14,3
				// for that considering last value - 3
				source = Number(source?.split(",")?.slice(-1)?.[0])
			}
			console.log("source", source);
			const iosSource=[3,23,53]
			if(iosSource.includes(source)){
				checkBasedOnSource(source,resolve)
			} else{
				const androidSrc=[1,21,51];
				if (androidSrc.includes(source)) {
					setCookieUsingObj(checkBasedOnSource(source));
					resolve()	
				} else {
					let mobileno = getCookie("userProfile") && JSON.parse(decodeURIComponent(getCookie("userProfile"))) && JSON.parse(decodeURIComponent(getCookie("userProfile")))['mobile'] || getCookie("mobile") || getQueryParam('mobile');
					
					axios.post(`/vendor/manage-products-genio/${token}/api/getUserProfileData.ns`, {})
					.then((response)=>{
						/* this block can be removed later once userprofile cookie will be stopped */						
						if (response?.data?.isSuccess && response?.data?.m) {
							mobileno = decryptData(response?.data?.m, true, 'jdDcCrypto');
						}
						setCookieUsingObj({mobile: mobileno});
						setCookieUsingObj(checkBasedOnSource(source));
						resolve()
					})
					.catch(err=>{
						console.log('getUserProfileData error catched', err, mobileno);
						setCookieUsingObj({mobile: mobileno});
						setCookieUsingObj(checkBasedOnSource(source));
						resolve()
					})
				}				
			}			
			console.log("entered setCurrentDeviceDetails fn");
		}
	})
	
}

export function redirectToLogin(redirectlogin,source){
    if(parseInt(source) === 53){
		var logjson = JSON.stringify({'type':'verticalLogin','fn':'getLoginData'});
		window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
	} else if (parseInt(source) === 51) {
     	var logoutjson = JSON.stringify({"action":"logout"});
		JdLiteInterface.verticalHandler(logoutjson);
		window.location.reload();
		return;
		// var logjson = JdLiteInterface.getLoginData();
		// if (logjson && logjson != '') {
		// 	var logresponse = JSON.parse(logjson);
		// 	return {
		// 		mobile:logresponse.mobile,
		// 		source,
		// 		sid:logresponse.sid,
		// 		deviceId:logresponse.device_details.deviceid,
		// 		version :logresponse.devicebuildversion,
		// 	}
		// }
    } else {
      let url = 'https://www.justdial.com/login?redirect='+encodeURIComponent(redirectlogin);
      window.location.href=url;
    }
}

export const getQueryParam = name => {
	// const params = new Proxy(new URLSearchParams(window.location.search), {
	// 	get: (searchParams, prop) => searchParams.get(prop),
	// });
	// return params[name];
	return new URLSearchParams(window.location.search).get(name) || "";
}

// export const getCookie = (name) => {
// 	if (!document.cookie.includes(name)) {
// 		return '';
// 	}
// 	let temp = document.cookie.split(name + '=')[1];
// 	return temp.split(';')[0]
// }

export const getCookie = (cname) => {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
	  var c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
}

export const setCookieUsingObj = obj => {
	for (const prop in obj) {
		setCookie(prop, obj[prop], 1);
	}
}

const getLoginData = res => {
	console.log(res)
	return res;
}

const getLoginDataForIOS = (res) => {
  console.log("entered getLoginData callback")
  console.log("res", res)
  var logresponse = JSON.parse(res)
  let userInfo = {
    mobile: logresponse.mobile,
    sid: logresponse.sid,
    deviceId: logresponse?.device_details?.deviceid,
    version: logresponse?.devicebuildversion,
  }
  setCookieUsingObj(userInfo)
  console.log("userInfo", userInfo)
  console.log(document.cookie)
  console.log("entered getLoginData callback")
  return userInfo
}


export const universalClose = (fromDashboard,historyHandler,dontClose) => {
	if(!dontClose){
		historyHandler.closeAll();
	}
	if(fromDashboard){
		setTimeout(()=>{
			window.history.go(-1);
		},0);
	}
}

export const discountCalculator = (sellingPrice, mrp) => {
	const discountPercent = ((Number(mrp)-Number(sellingPrice)) / Number(mrp)) * 100;
	return parseInt(discountPercent);
}

export  const errorEmail = (error,debugDtls) => {
    try {
		// if(process.env.NODE_ENV !== "production" && config.hostKey.toLowerCase()!='omega'){
        //     return;
        // }
		const {from} = debugDtls;
		const typeOfError = {
			"backend": "apiResponse",
			"frontEnd": "javascript",
			"dcServer": "urlRequest"
		}
        const errorJSON = {
            "event": "ERROR",
			"error": error.message,
			"trace": error.stack,
			...debugDtls
        }
        const errorLog = JSON.stringify(errorJSON);
        const emailText = `Hi Team,
                <br></br>
                Timing
                ${new Date().toISOString()}
				<br></br>
                Internal Server Occured Error log
                ${errorLog}
                <br></br>
                Regards,
                <br></br>
                Omni Marketplace Team
        `
    // const emailBody = {
    //     source: `Omni Marketplace ${typeOfError[from]} Logs`,
    //     email_id: "sandeep.jaiswar3@justdial.com",
    //     fromName:'Just Dial',
    //     email_subject: `Omni Marketplace ${typeOfError[from]} Error`,
    //     email_text:emailText,
    //     sender_email:'instantemail@justdial.com',
    //     sender_name: 'Omni Marketplace Team',
    //     email_id_cc:"yogesh.kokel@justdial.com,anil.kumar@justdial.com,bhavik.upadhyay@justdial.com",
    //     email_id_bcc:"",
    //     reply_to:'noreply@justdial.com',
    // }
    // const emailOptions = {
    //     url:`http://192.168.20.116/insert_email.php`,
    //     data:queryString.stringify(emailBody),
    //     method: "post"
    // }
    return axios
      .post("/marketplace/send-marketplace-error-mail.ns", {
        errorType: typeOfError[from],
        emailText: emailText,
      })
      .then(() => {
        console.log("mail sent")
      })
      .catch((err) => {
        console.log(err)
      })
  } catch (error) {
    console.log(error)
    return Promise.resolve()
  }
}


export const fetchAuditEnrichProduct = async (cb) => {
        const product = await axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=fetchEnrichmentProduct&queueType=brandedEnrich`)
        if (product.data.status == 1){
            let [urlParse] = (product.data.url.split('/'))
            if (process.env?.NODE_ENVIRONMENT && process.env?.NODE_ENVIRONMENT != 'LOCAL'){
                window.location.href =  product.data.url
            }else {
                window.location.href = product.data.url.replace(config.serverApiDomain, window.location.protocol+'//'+config.auditorDomain);
            }
        }else {
            // setFailResponse('No Product Found In Queue')
			cb && cb('No Product Found In Queue');
			// return 'No Product Found In Queue';
            // await history.push('/audit-enrich-home')
        }
    }
	
export const backToApp = () => {
	const source = Number(getQueryParam('source'));
	const b2bhome = Number(getQueryParam('b2bhome'));
	if(b2bhome) {
		if(['1'].includes(source) && JdLiteInterface){
			if(JdLiteInterface.getVerifiedSuccessRefresh && Number(version) >= 1059) {
				JdLiteInterface.getVerifiedSuccessRefresh('{"refresh":1}');
			}else if(JdLiteInterface.getVerifiedSuccess) {
				JdLiteInterface.getVerifiedSuccess();
			}
		} else if(['3'].includes(source) && webkit?.messageHandlers?.callbackHandler) {
			if(Number(version) >= 14.1) {
				window.webkit.messageHandlers.callbackHandler.postMessage('{"type":"get_verified_success_with_refresh"}');
			}else {
				window.webkit.messageHandlers.callbackHandler.postMessage('{"type":"get_verified_success"}');
			}
		}
	}
	window.location.href = 'https://jdext.php';
}


export const getPlatform = function () {
	let session = getSessionStore();
	const source = Number(session.jdSource);
	const androidSrc = [1, 21, 51];
	const iosSrc = [3, 23, 53];
	const touchSrc = [2, 22, 52];
	const webSrc = [7, 27, 57, 77];
	const genioSrc = [14];
	
	let retValue = "";
  
	if (source) {
	  retValue = androidSrc.includes(source)
		? "android"
		: iosSrc.includes(source)
		? "ios"
		: touchSrc.includes(source)
		? "touch"
		: webSrc.includes(source)
		? "web"
		:  genioSrc.includes(source)
		? "genio"
		: "";
	  if (source === 2 && retValue === "touch") {
		retValue = "jdlite";
	  }
	}
	return retValue;
}

export const filterDataAry = (type, cb,viaOmni) => {
	let filterAry = [];
	let session = getSessionStore();

	let showScore = ((session.user?.loggedUser?.userType != "AUDITOR") &&  session.newProfile != 1)
	if (type === "tabkey-brand") {
		filterAry = [{
			type: "checkbox",
			label: "Product Status",
			variant: "circle",
			serviceKey: "sortProductStatus",
			subMenu: [
			{
				label: "Activated",
				value: "Activated",
				isChecked: cb("sortProductStatus", "Activated"),
			},
			{
				label: "Deactivated",
				value: "Deactivated",
				isChecked: cb("sortProductStatus", "Deactivated"),
			},
			],
		}]
	} else if (type === "audit-showSearchAdd") {
		filterAry = [{
			type: "checkbox",
			label: "Sort By",
			variant: "circle",
			serviceKey: "sortAuditStatus",
			subMenu: [
			{
				label: "Status",
				value: "Status",
				isChecked: cb("sortAuditStatus", "Status"),
			},
			{
				label: "Creation Date",
				value: "CreationDate",
				isChecked: cb("sortAuditStatus", "CreationDate"),
			},
			{
				label: "Last Modified",
				value: "LastModified",
				isChecked: cb("sortAuditStatus", "LastModified"),
			},
			{
				label: "A - Z",
				value: "A-Z",
				isChecked: cb("sortAuditStatus", "A-Z"),
			},
			],
		},{
			type: "checkbox",
			label: "Audit Status",
			variant: "circle",
			serviceKey: "filterAuditStatus",
			subMenu: [
			{
				label: "Audited",
				value: "Audited",
				isChecked: cb("filterAuditStatus", "Audited"),
			},
			{
				label: "Audited - Sampled",
				value: "Sampled",
				isChecked: cb("filterAuditStatus", "Sampled"),
			},
			{
				label: "Audit Pending",
				value: "AuditPending",
				isChecked: cb("filterAuditStatus", "AuditPending"),
			},
			{
				label: "Audit Not Required",
				value: "AuditNotRequired",
				isChecked: cb("filterAuditStatus", "AuditNotRequired"),
			},
			{
				label: "Audited - Vendor Approval Pending",
				value: "AuditVenAppPending",
				isChecked: cb("filterAuditStatus", "AuditVenAppPending"),
			},
			],
		}]
	} else {
		filterAry = [
			{
				label: 'Brand',
				placeholder:'Search Brand',
				serviceKey:'brands'
			}
		];
		if (!viaOmni) {
			filterAry = [...filterAry,{
				type: 'checkbox',
				label: 'Live Status',
				variant: 'circle',
				serviceKey: 'live',
				subMenu: [
					{
						label: 'Yes',
						value: 'yes',
						isChecked: cb('live', 'yes')
					},
					{
						label: 'No',
						value: 'no',
						isChecked: cb('live', 'no')
					}
				]
			}];	
		}
		filterAry = [...filterAry, {
				type: 'checkbox',
				label: 'Hidden Status',
				variant: 'circle',
				serviceKey: 'visibility',
				subMenu: [
					{
						label: 'Hidden',
						value: 'no',
						isChecked: cb('visibility', 'no')
					},
					{
						label: 'Unhidden',
						value: 'yes',
						isChecked: cb('visibility', 'yes')
					}
				]
			},
			{
				type: 'checkbox',
				label: 'Image Present',
				variant: 'circle',
				serviceKey: 'imagePresent',
				subMenu: [
					{
						label: 'Yes',
						value: 'yes',
						isChecked: cb('imagePresent', 'yes')
					},
					{
						label: 'No',
						value: 'no',
						isChecked: cb('imagePresent', 'no')
					}
				]
			},
			{
				type: 'checkbox',
				label: 'Price Present',
				variant: 'circle',
				serviceKey: 'pricePresent',
				subMenu: [
					{
						label: 'Yes',
						value: 'yes',
						isChecked: cb('pricePresent', 'yes')
					},
					{
						label: 'No',
						value: 'no',
						isChecked: cb('pricePresent', 'no')
					}
				]
			},
			{
				type: 'checkbox',
				label: 'Category Present',
				variant: 'circle',
				serviceKey: 'categoryPresent',
				subMenu: [
					{
						label: 'Yes',
						value: 'yes',
						isChecked: cb('categoryPresent', 'yes')
					},
					{
						label: 'No',
						value: 'no',
						isChecked: cb('categoryPresent', 'no')
					}
				]
			}
		]
	}

	if (type !== "tabkey-brand" && !viaOmni) {
		filterAry = [...filterAry,{
			type: "checkbox",
			label: "Specifications Present",
			variant: "circle",
			serviceKey: "specPresent",
			subMenu: [
			{
				label: "Yes",
				value: "yes",
				isChecked: cb("specPresent", "yes"),
			},
			{
				label: "No",
				value: "no",
				isChecked: cb("specPresent", "no"),
			},
			],
		},{
			type: "checkbox",
			label: "Description Present",
			variant: "circle",
			serviceKey: "descPresent",
			subMenu: [
			{
				label: "Yes",
				value: "yes",
				isChecked: cb("descPresent", "yes"),
			},
			{
				label: "No",
				value: "no",
				isChecked: cb("descPresent", "no"),
			},
			],
		}];
		if(showScore) {
			filterAry = [...filterAry, {
				type: "checkbox",
				label: `${session?.profileObject?.SingleLabelWithSpace} Score`,
				variant: "circle",
				serviceKey: "score",
				subMenu: [
				{
					label: "Equal to 100",
					value: "equalToHundred",
					isChecked: cb("score", "equalToHundred"),
				},
				{
					label: "Less than 100",
					value: "lessThanHundred",
					isChecked: cb("score", "lessThanHundred"),
				},
				],
			}];
		}
	}

	return filterAry;
};

export const removeFromUrl = (route) => {
	const strInd = window.location.pathname.indexOf(route)
	const newPath = strInd != -1 ? window?.location?.pathname.slice(0, strInd) : window?.location?.pathname
	window?.history?.pushState({}, "", newPath)
}

export const customUrlHandler = (isLoggedIn, pathname, supplierId, history, showAddPriceTag, showOutDatedPriceTag, showCategoryMissingCard) => {
	if (isLoggedIn) {
		if (pathname === "/products/smartcard/priceMissingCount" && !showAddPriceTag && supplierId) {
			AddPriceCardDataonClick()
			removeFromUrl("/smartcard/priceMissingCount")
		}else if (pathname === "/products/smartcard/smartPriceMissingCount" && !showOutDatedPriceTag && supplierId) {
			getOutDatedPriceCardData()
			removeFromUrl("/smartcard/smartPriceMissingCount")
		}else if (pathname === "/products/smartcard/nonexistingjdmartidcount" && !showCategoryMissingCard && supplierId) {
			getCategoryMissingCardData()
			removeFromUrl("/smartcard/nonexistingjdmartidcount")
		}
	} else {
		// this bcoz if i redirect to auth then user close the auth it going on loop and if we use history.replace then it close user browser
		history.push("/products")
		history.push("/products/auth")
	}
}


export const checkNFilterMultipleSlashes = function (urlPath='') {
	try {
		if (-1===urlPath.indexOf('//', 8)) {
			return urlPath;
		}
		const debugDtls = {
			url: urlPath,
			sid: getCookie("sid"),
			from: "dcClient"
		};
		const errorObj = {
			message: 'Error in URL',
			stack:   urlPath	
		};				
		errorEmail(errorObj, debugDtls);
		let hasProtocol = (-1!==urlPath.toLowerCase().indexOf('https://') ? 'https://' : -1!==urlPath.toLowerCase().indexOf('http://') ? 'http://' : '');
		urlPath = hasProtocol!='' ? urlPath.split(hasProtocol)[1] : urlPath;
		return  hasProtocol+urlPath.replace(/(\/)+/g, '/');			
	} catch(e) {
		console.log('dcClient: Error in URL', e);
		return false;
	}	
}
	
export const checkAutoLogin = async (token, user) => {	
	if (user!=='OWNER' && typeof user!=='undefined') return false;
	let fromAutoLogin = false;
	const getSessionUrl = `/vendor/manage-products-genio/${token}/api/getSession.ns`;
	const res = await axios.get(getSessionUrl);
	if(res.data.isSuccess && res.data.fromAutoLogin){
		fromAutoLogin = true;
	}	
	return fromAutoLogin;
}

export const openHelpUrl = (key, isMobile) => {
	const linksObj = {
		'Products-Add-New-Product-Add-Product-One-By-One': "/products/add-update#addnewproduct",
		// 'Products-Add-New-Product' : "/products/add-update#addnewproduct",
		'Products-Edit-Product' : "/products/add-update#updateproducts",
		'Products-View-Products-Bulk-Add-New-Products' : "/products/add-update#importproducts",
		'Products-Edit-Brands' : "/products/edit-products-by-brands-and-categories#editproductbrands",
		'Products-Edit-Categories' : "/products/edit-products-by-brands-and-categories#editproductcategories",
		'Products-View-Bulk-Update-Products': "/products/add-update#bulkupdateexistingproducts",
		'Products-View-Export-Products': "/products/add-update#exportproducts",
		'Products-Manage-Size-Chart': "/products/manage-size-chart"
	}

	let url = config.omniDomain;
	url = url + '/support' + linksObj[key];

	if(isMobile){
		let lastPageUrl = location.href;
		url += (url.indexOf('?') == -1 ? '?' : '&') + 'last_page=' + encodeURIComponent(lastPageUrl)
	}
	if (window.jdInterface && window.jdInterface.openUrlInBrowser) {
		window.jdInterface.openUrlInBrowser(url);
	} else {
		window.open(url, '_blank');
	}
}

export const fetchSupplierData = (brand, manufacturer, details, cb) => {
	if(!brand && !manufacturer){
		cb([],brand,manufacturer);
		return;
	}
	axios.get('/marketplace/products/ajax/getLinkedVendors.service?brand='+brand+'&manufacturer='+manufacturer+'&isFullDetailsRequired='+details)
	.then((res)=>{
		cb(res.data.data,brand,manufacturer);
	})
}

export const isBeyondRange = (chkVal, minVal, maxVal) => {
    return (Number(chkVal) < Number(minVal) || Number(chkVal) > Number(maxVal));
}
export const checkUomType = (uom, serviceUOM) => {
	const strArr = uom.split(" ")
	if (uom.toLowerCase().includes("session") || uom.toLowerCase().includes("sess")) {
		return { type: "Sess", value: isNaN(strArr[0]) ? 1 : strArr[0], obj: getMatchedUOM(serviceUOM, "Sess") }
	} else if (uom.toLowerCase().includes("visit")) {
		return { type: "Visit", value: isNaN(strArr[0]) ? 1 : strArr[0], obj: getMatchedUOM(serviceUOM, "Visit") }
	} else {
		return { type: uom, value: "", obj: {} }
	}
}

export const encryptData = (data, isText = true, secretKey = "jdDcCrypto") => {
	const payload = isText ? data : JSON.stringify(data)
	const cipherData = CryptoJS.AES.encrypt(payload, secretKey).toString();
	return cipherData
}

export const decryptData = (data, isText = true, secretKey = "jdDcCrypto") => {
	const bytes = CryptoJS.AES.decrypt(data, secretKey);
	const ogData = bytes.toString(CryptoJS.enc.Utf8);
	const finalData = isText ? ogData : JSON.parse(ogData)
	return finalData
}

export const updtLbl = (cnt = 0, lbl='') => {
    return cnt > 1 ? lbl.replace('Product', 'Products').replace('Service', 'Services') : lbl
}

export const openPageWithToken = function(url,target = '_self') {
	function extractAndRemoveToken(url) {
		const parsedUrl = new URL(url);

		const token = parsedUrl.searchParams.get("token");
		parsedUrl.searchParams.delete("token");

		return {
			token,
			cleanUrl: parsedUrl.toString()
		};
	}
	const {cleanUrl,token} = extractAndRemoveToken(url);
	sessionStorage.setItem("authToken", token);
	const form = parent.document.createElement("form");
  	form.method = "POST";
  	form.action = cleanUrl;
  	form.target = target;

  	const input = parent.document.createElement("input");
  	input.type = "hidden";
  	input.name = "token";
  	input.value = token;
  	form.appendChild(input);

  	parent.document.body.appendChild(form);
  	form.submit();
}

export const notifyCatalogueCreated = () => {
	try {
		if (window.webkit && window.webkit.messageHandlers['callbackHandler']) {
			window.webkit.messageHandlers['callbackHandler'].postMessage(
				JSON.stringify({type: 'catalogueUploaded'})
			)
		} else if (window.JdLiteInterface) {
			window.JdLiteInterface.openDetails(
				JSON.stringify({ redirectiontype: 'cataloguedone', done: '1' })
			)
		}
	} catch(e) {
		console.log(e);
	}
}
